export function ConstructorAsFunction(Class) {
    return (...args) => new Class(...args);
}
//# sourceMappingURL=constructor_as_function.js.map